'use client';
import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { BookOpen, Users, Award } from 'lucide-react';

const highlights = [
  { id: 'h-1', icon: <BookOpen size={16} />, text: '200+ courses in AI, Data Science & Health Informatics' },
  { id: 'h-2', icon: <Users size={16} />, text: 'Join 18,400+ learners in our active community' },
  { id: 'h-3', icon: <Award size={16} />, text: 'Earn certificates recognised by industry partners' },
];

export default function AuthBrand() {
  return (
    <div className="hidden lg:flex flex-col justify-between w-[520px] flex-shrink-0 gradient-primary p-12 text-white relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-white/5" />
      <div className="absolute bottom-10 -left-10 w-48 h-48 rounded-full bg-white/5" />
      <div className="absolute top-1/2 right-10 w-24 h-24 rounded-full bg-white/10" />
      {/* Logo */}
      <div className="flex items-center gap-3 relative z-10">
        <AppLogo size={40} />
        <span className="font-bold text-2xl tracking-tight">EugeneTechRN</span>
      </div>
      {/* Main copy */}
      <div className="relative z-10">
        <h1 className="text-hero-md font-extrabold leading-tight mb-4">
          Learn AI, Data Science &amp; Health Informatics
        </h1>
        <p className="text-white/75 text-base leading-relaxed mb-8">
          Structured courses, hands-on exercises, and a thriving community — all in one place. Build skills that matter.
        </p>
        <div className="space-y-3">
          {highlights?.map((h) => (
            <div key={h?.id} className="flex items-center gap-3 text-sm text-white/85">
              <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                {h?.icon}
              </span>
              {h?.text}
            </div>
          ))}
        </div>
      </div>
      {/* Testimonial */}
      <div className="relative z-10 bg-white/10 rounded-2xl p-5 backdrop-blur-sm">
        <p className="text-sm text-white/90 leading-relaxed italic">
          &ldquo;EugeneTechRN&rsquo;s ML course completely changed my career trajectory. The community is incredibly supportive.&rdquo;
        </p>
        <div className="flex items-center gap-3 mt-3">
          <div className="w-8 h-8 rounded-full bg-white/30 flex items-center justify-center text-xs font-bold">TW</div>
          <div>
            <p className="text-xs font-semibold">Taiwo Adeyemi</p>
            <p className="text-xs text-white/60">ML Engineer, Lagos</p>
          </div>
        </div>
      </div>
    </div>
  );
}